import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

// import Booths from '../data/booths.json';

import { Vector3 } from 'three';
import { BoothItem, BoothModel } from '../models';
import { BoothService } from './booth.service';

enum STATES {
    START = 0,
    WELCOME,
    CENTER,
    MED_INFO,
    BAYER,
    BOOTH1,
    BOOTH2,
    BOOTH3,
    BOOTH4,
    BOOTH5,
    __LENGTH
};
@Injectable({
    providedIn: 'root'
})
export class StateService {
    public currentState = new BehaviorSubject(STATES.START);
    private _nState = STATES.START;
    private _prevState = -1;
    private NUM_BOOTHS: number = 0;

    public DEG_TO_RAD: number = 0.0174532925;
    public CENTER_POINT: Vector3 = new Vector3(-690, 0, 570);

    public ONE_BOOTH_SHOW: Boolean = false;
    public boothData: BoothModel;
    public states = STATES;
    public headerOpen = new BehaviorSubject(false);

    private cameraH = 200;
    public coordinates: Array<Vector3> = [
        new Vector3(0, this.cameraH, 3000),
        new Vector3(50, 82, 2324),
        new Vector3(0, this.cameraH, 0)
    ];

    public lookAtCoords: Array<Vector3> = [
        new Vector3(0, this.cameraH, 0),
        new Vector3(50, 125, 1800),
        new Vector3(0, this.cameraH, -200)
    ];

    public boothRotations: Array<number> = [
        242,
        191,
        147,
        98,
        47,
        359,
        312
    ];

    constructor(
        private boothService: BoothService,
        private router: Router
    ) {
        this.boothService.boothDataUpdated.subscribe(data => {
            console.log('boothDataUpdated ', data)
            this.boothData = this.boothService.boothModel;
            console.log("State Service Booths: ~", this.boothData.booths.length)
            this.NUM_BOOTHS = this.boothData.booths.length + 3; // Include Start, Welcome and Center states.

            switch (this.boothService.NUM_BOOTHS) {
                case 4: // 2 booth config with bayer and medinfo.
                    this.lookAtCoords[STATES.CENTER].x = -120;
                    break;
                case 3: // 1 Booth with Bayer.
                    this.lookAtCoords[STATES.CENTER] = new Vector3(-250, this.cameraH, -50)
                    break;
                case 2: // 1 Booth no Bayer
                    this.ONE_BOOTH_SHOW = true;
                    break;
                default:
                    break;
            }
        });
    }

    public setState(data): void {
        this._prevState = this._nState;
        this._nState = data;
        if (this._nState === STATES.CENTER && this.ONE_BOOTH_SHOW) {
            this._nState = STATES.BOOTH1;
        }
        this.currentState.next(this._nState);
        this.setUrlAndColors();
    }

    public nextState(): void {
        this._nState += 1;
        console.log('this._nState', this._nState, this.NUM_BOOTHS)
        if (this._nState >= this.NUM_BOOTHS) {
            // this._nState = this.NUM_BOOTHS - 1;
            this._nState = STATES.CENTER;
        } else if (this._nState === STATES.CENTER && this.ONE_BOOTH_SHOW) {
            this._nState = STATES.BOOTH1;
        }
        this.currentState.next(this._nState);
        this.setUrlAndColors();
    }

    public prevState(): void {
        this._nState -= 1;
        if (this._nState < 0) {
            this._nState = 0;
        } else if (this._nState === STATES.CENTER && this.ONE_BOOTH_SHOW) {
            this._nState = STATES.BOOTH1;
        }
        this.currentState.next(this._nState);
        this.setUrlAndColors();
    }

    private setUrlAndColors(): void {
        const data: BoothItem = this.boothData.booths.find(el => el.id === this._nState);
        if (data) {
            this.router.navigateByUrl(data.url);

            console.log('setURLandColors', data);
            const bgColor = data.bg_color ? data.bg_color : '#003851';
            const accentColor = data.hover ? data.hover : '#63b620';
            const hotspotTextColor = data.hotspotText ? data.hotspotText : accentColor;

            document.documentElement.style.setProperty('--booth_bg', bgColor);
            document.documentElement.style.setProperty('--booth_accent', accentColor);
            document.documentElement.style.setProperty('--hotspot_color', hotspotTextColor);
            // } else if (this._nState === STATES.WELCOME) {
        } else {
            this.router.navigateByUrl('/');
        }

    }

    public getStateCoordinates(radius: number = 550): Vector3 {

        if (this._nState > STATES.CENTER) {
            let rtnVal = new Vector3(0, this.cameraH, 0)
            // let angleOffset = 360 / 8;    // Do some cool math here.
            if (this._nState === STATES.MED_INFO) {
                // radius = 600;
            }
            let angleOffset: number = this.boothRotations[this._nState - STATES.MED_INFO];
            rtnVal.x = radius * Math.cos(angleOffset * this.DEG_TO_RAD);
            rtnVal.z = radius * Math.sin(angleOffset * this.DEG_TO_RAD) * -1;
            return rtnVal;
        } else {
            return this.coordinates[this._nState];
        }

    }
    public getCoordinatesById(id: number, radius: number = 500): Vector3 {

        if (id > STATES.CENTER) {
            let rtnVal = new Vector3(0, this.cameraH, 0)

            let angleOffset: number = this.boothRotations[id - STATES.MED_INFO];
            if (this._nState === STATES.MED_INFO) {
                // angleOffset = 225;
            }
            rtnVal.x = radius * Math.cos(angleOffset * this.DEG_TO_RAD);
            rtnVal.z = radius * Math.sin(angleOffset * this.DEG_TO_RAD) * -1;
            return rtnVal;
        } else {
            return this.coordinates[id];
        }

    }
    public getBoothRotation(nId: number = null): number {
        nId = (nId) ? nId : this._nState;
        console.log('getBoothRotation', nId);
        if (nId > STATES.CENTER) {
            return this.boothRotations[nId - STATES.MED_INFO];
        } else {
            return 0;
        }
    }

    public getRotationLimits(): Array<any> {
        console.log('this.NUM_BOOTHS, ', this.boothService.NUM_BOOTHS, this.boothRotations.length, this.NUM_BOOTHS, STATES.__LENGTH)

        if (this.boothService.NUM_BOOTHS >= this.boothRotations.length) {
            // 5 Booth Config.
            return [this.boothRotations[0] - 7, this.boothRotations[STATES.MED_INFO] - 5];
        } else {
            return [this.boothRotations[this.boothService.NUM_BOOTHS] - 49, this.boothRotations[STATES.MED_INFO] - 5];
        }

    }

    public getLookatCoords(radius: number = 1500): Vector3 {

        if (this._nState > STATES.CENTER) {
            // let angleOffset = 360 / 8;    // Do some cool math here.
            const lookAt = new Vector3(0, this.cameraH, 0)
            let angleOffset: number = this.boothRotations[this._nState - STATES.MED_INFO];
            if (this._nState === STATES.MED_INFO) {
                angleOffset -= 4;
            }
            lookAt.x = radius * Math.cos(angleOffset * this.DEG_TO_RAD);
            lookAt.z = radius * Math.sin(angleOffset * this.DEG_TO_RAD) * -1;
            return lookAt;
        }
        return this.lookAtCoords[this._nState];
    }

    public getLookatCoordsById(id: number, radius: number = 1500): Vector3 {

        if (id > STATES.CENTER) {
            // let angleOffset = 360 / 8;    // Do some cool math here.
            const lookAt = new Vector3(0, this.cameraH, 0)
            let angleOffset: number = this.boothRotations[id - STATES.MED_INFO];
            if (id === STATES.MED_INFO) {
                angleOffset -= 4;
            }
            lookAt.x = radius * Math.cos(angleOffset * this.DEG_TO_RAD);
            lookAt.z = radius * Math.sin(angleOffset * this.DEG_TO_RAD) * -1;
            return lookAt;
        }
        return this.lookAtCoords[id];
    }

    public setHeaderOpen(data: boolean): void {
        this.headerOpen.next(data);
    }
}
